
import {IElement, ITextAttributes, ITextSelectionInformation} from 'routes/private/Editor/types';
import { execCommandToSelectedText, updateRenderingTextSegments } from 'utils/textMultiStyling'

export const fontSuperscriptResolver = ( element: IElement, value?: number, textSelectionInformation?: ITextSelectionInformation ) => {    
    if (element.type === "Text") {
        const attributes = execCommandToSelectedText("superscript", (element.attributes as ITextAttributes), textSelectionInformation, value);
        element.attributes = updateRenderingTextSegments(attributes);
    }
    return element;
}